import React from 'react';
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';
import ContactForm from '../components/common/ContactForm/ContactForm';
import styles from './Contact.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';

function Contact() {
  return (
    <>
      <RealisationsHero
        title="Contactez-nous"
        subtitle="Une question, un projet ? Nous sommes à votre écoute pour donner vie à vos idées."
        backgroundImage="/images/pergola1.jpg" // Make sure this image exists
      />
      <section className="section">
        <div className="container">
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <div className={styles.introText}>
                <span className={styles.eyebrow}>À votre écoute</span>
                <h2 className={styles.title}>Parlons de votre projet</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Que vous ayez une idée précise ou simplement une question, notre équipe est là pour vous écouter et vous guider. Remplissez le formulaire ou contactez-nous directement.
                </p>
                <div className={styles.highlightNotice}>
                  <p>Chaque grand projet commence par une simple conversation.</p>
                </div>
              </div>
              <div className={styles.introImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/pergola3.jpg" alt="Pergola en bois Maison Quinard" className={styles.mainImage} />
                  <div className={styles.contactBadge}>
                    <span className={styles.badgeLabel}>Conseils</span>
                    <span className={styles.badgeText}>Écoute Active</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>

          <div className={styles.contactLayout}>
            {/* Colonne de gauche : Infos + Carte */}
            <div className={styles.infoColumn}>
              <span className={styles.eyebrow}>Coordonnées</span>
              <h3 className={styles.sectionTitle}>Maison Quinard</h3>
              <div className={styles.smallDivider}></div>

              <ul className={styles.infoList}>
                <li className={styles.infoItem}>
                  <div className={styles.iconCircle}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>
                  <div className={styles.infoTextContent}>
                    <strong>Siège Social</strong>
                    <span>22 Rue du Paradis, 78790 Arnouville-lès-Mantes</span>
                  </div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconCircle}>
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className={styles.infoTextContent}>
                    <strong>Ligne Directe</strong>
                    <span>06 58 06 27 20</span>
                  </div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconCircle}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className={styles.infoTextContent}>
                    <strong>Email Professionnel</strong>
                    <a href="mailto:contact@maison-quinard.com">contact@maison-quinard.com</a>
                  </div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconCircle}>
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div className={styles.infoTextContent}>
                    <strong>Horaires d'Ouverture</strong>
                    <span>Lundi - Vendredi: 8h-12h / 14h-18h</span>
                  </div>
                </li>
              </ul>

              <div className={styles.mapCard}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.991625992268!2d1.6918240156744838!3d48.85837397928751!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6a4e6b5d0b5d1%3A0x5d5d5d5d5d5d5d5d!2s22%20Rue%20du%20Paradis%2C%2078790%20Arnouville-l%C3%A8s-Mantes!5e0!3m2!1sfr!2sfr!4v1633362633333!5m2!1sfr!2sfr"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localisation Maison Quinard"
                ></iframe>
              </div>
            </div>

            {/* Colonne de droite : Formulaire */}
            <div className={styles.formColumn}>
              <div className={styles.formCard}>
                <span className={styles.eyebrow}>Directement</span>
                <h3 className={styles.sectionTitle}>Envoyez un message</h3>
                <div className={styles.smallDivider}></div>
                <ContactForm />
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Contact;
